import LoadingPanel from "./loadingPanel.component";

export default LoadingPanel;
